export enum RoleName {
    ADMINISTRATOR = 'administrator',
    CUSTOMER      = 'customer',
    DESIGNER      = 'designer',
    GUEST         = 'guest',
}